/* eslint-disable import/prefer-default-export */
export const uploadSampleFileName = {
  vehicledetail: 'vehicleAvailabilityBulkUpload.xlsx',
  vehicleDetailBulkUpload: 'vehicleDetailBulkUploadSample.xlsx',
};
